<ng-container *ngIf="routerLink; else externalLink">
  <a [routerLink]="routerLink" class="link">
    <div class="more-button {{colorScheme.main}}">
      <span>{{title}}</span>
      <mat-icon>arrow_forward</mat-icon>
    </div>
  </a>
</ng-container>
<ng-template #externalLink>
  <a [href]="link" class="link">
    <div class="more-button {{colorScheme.main}}">
      <span>{{title}}</span>
      <mat-icon>arrow_forward</mat-icon>
    </div>
  </a>
</ng-template>
